import { IExam } from "@/@types";
import { create } from "zustand";

interface AssessmentState {
  selectedItem: IExam | null;
  setSelectedItem: (value: IExam | null) => void;
  clearSelectedItem: () => void;
}

export const useAssessmentStore = create<AssessmentState>((set) => ({
  selectedItem: null,
  setSelectedItem: (value: IExam | null) => set({ selectedItem: value }),
  clearSelectedItem: () => set({ selectedItem: null }),
}));
